import { useState } from "react";
import { List, ListItem } from "@astryxdesign/core/List";
import { Button } from "@astryxdesign/core/Button";
import { Icon } from "@astryxdesign/core/Icon";
import { Text } from "@astryxdesign/core/Text";
import { VStack } from "@astryxdesign/core/VStack";
import { Screen } from "@/components/layout/Screen";
import { Empty } from "@/components/states";
import { useStudio } from "@/features/studio/StudioRoot";
import { useBookingNav } from "@/features/booking/useBookingNav";
import { myBookings } from "@/lib/storage";
import { formatDateTime } from "@/lib/format";
import { useT } from "@/lib/i18n";

/** Links to this customer's bookings saved on this device (no account needed). */
export function MyBookingsScreen() {
  const studio = useStudio();
  const t = useT();
  const nav = useBookingNav();
  const [list, setList] = useState(() => myBookings.list(studio.slug));
  const now = Date.now();
  const upcoming = list.filter((b) => new Date(b.startsAt).getTime() > now).sort((a, b) => a.startsAt.localeCompare(b.startsAt));
  const past = list.filter((b) => new Date(b.startsAt).getTime() <= now);

  return (
    <Screen title={t.my.title}>
      {list.length === 0 ? (
        <Empty
          title={t.my.emptyTitle}
          description={t.my.emptyText}
          action={<Button label={t.home.book} variant="primary" onClick={() => nav.open()} />}
        />
      ) : (
        <VStack gap={4}>
          {upcoming.length ? (
            <List hasDividers header={<Text type="label" color="secondary">{t.my.upcoming}</Text>}>
              {upcoming.map((b) => (
                <ListItem
                  key={b.token}
                  label={b.serviceName}
                  description={formatDateTime(b.startsAt, studio.timezone)}
                  endContent={<Icon icon="chevronRight" color="secondary" />}
                  href={`/s/${studio.slug}/b#t=${b.token}`}
                />
              ))}
            </List>
          ) : null}
          {past.length ? (
            <List hasDividers header={<Text type="label" color="secondary">{t.my.past}</Text>}>
              {past.map((b) => (
                <ListItem
                  key={b.token}
                  label={b.serviceName}
                  description={formatDateTime(b.startsAt, studio.timezone)}
                  href={`/s/${studio.slug}/b#t=${b.token}`}
                />
              ))}
            </List>
          ) : null}
          <Button
            label={t.my.forget}
            variant="ghost"
            onClick={() => {
              for (const b of list) myBookings.remove(studio.slug, b.token);
              setList([]);
            }}
          />
        </VStack>
      )}
    </Screen>
  );
}
